export const getTehsilesOfDistrictSuccess = (data) => ({
	type: "GET_TEHSILES_OF_DISTRICT_SUCCESS",
	data,
});

export const getTehsilesOfDistrictFail = (error) => ({
	type: "GET_TEHSILES_OF_DISTRICT_FAIL",
	error,
});
export const getTehsilesbyDistrict = (obj) => ({
  type: "TEHSILES_BY_DISTRICT",
  obj,
});